import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeSourceList } from "../../../Art57Node/ListEntity/TreeNodeSourceList";

export class SourceQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).sourceFields;
    const createChidTemplateParams = {nodeType: 2};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).sourceConditions;
       super(injector, [], 'Sources', EntityEnum.source,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.sourceTreeNode, TreeNodeSourceList, AutoUploadEntityEnum.source, createChidTemplateParams);    
    }
}